import React from 'react'

const YesNoBooleanValue: React.FC<{ value: boolean }> = ({ value }) => <>{value ? 'Yes' : 'No'}</>

export default YesNoBooleanValue
